export default {
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    setLoading(f = true) {
      this.loading = f;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/loadable.js